module.exports = __webpack_public_path__ + "static/media/OutliersQ4_4.3b9f8dd7.svg";